import { z } from "zod/v4";

export const ReturnChatSchema = z.object({ threadId: z.string().nullish() });
